module.exports = __webpack_public_path__ + "static/media/assembly7.ca4d5c30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameRocketRepair/assembly7.png
// module id = 2425
// module chunks = 0